/**
 * Analytics Tab Component for RNCM Productivity
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
  PieChart, Pie, Cell
} from 'recharts';

export const AnalyticsTab = ({
  outcomeData,
  capacityOutcomeData,
  disciplineSummaries
}) => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Productivity Outcomes Pie Chart */}
        <Card>
          <CardHeader>
            <CardTitle>Productivity Outcomes</CardTitle>
            <CardDescription>Distribution of clinician performance</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-64">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={outcomeData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={90}
                    paddingAngle={5}
                    dataKey="value"
                    label={({ name, value }) => `${name}: ${value}`}
                  >
                    {outcomeData.map((entry, index) => (
                      <Cell key={index} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>

        {/* Capacity Planning Outcomes Pie Chart */}
        <Card>
          <CardHeader>
            <CardTitle>Capacity Planning Outcomes</CardTitle>
            <CardDescription>RNCM capacity vs expectations</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-64">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={capacityOutcomeData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={90}
                    paddingAngle={5}
                    dataKey="value"
                    label={({ name, value }) => `${name}: ${value}`}
                  >
                    {capacityOutcomeData.map((entry, index) => (
                      <Cell key={index} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Discipline Visit Trends Bar Chart */}
      {disciplineSummaries.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Discipline Visit Trends</CardTitle>
            <CardDescription>Visit distribution over time</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-80">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={[...disciplineSummaries].reverse()}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="period_start" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="rncm_visits" name="RNCMs" fill="#4F46E5" />
                  <Bar dataKey="lpn_visits" name="LPNs" fill="#10B981" />
                  <Bar dataKey="wound_rn_visits" name="Wound RN" fill="#F59E0B" />
                  <Bar dataKey="prn_visits" name="PRNs" fill="#8B5CF6" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default AnalyticsTab;
